import { render } from "./LunarCalendar.vue?vue&type=template&id=16f3e8e2"
import script from "./LunarCalendar.vue?vue&type=script&lang=js"
export * from "./LunarCalendar.vue?vue&type=script&lang=js"

import "./LunarCalendar.vue?vue&type=style&index=0&id=16f3e8e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__